import { View } from 'react-native'
import { Star } from '@/components/ui/icons'
import { Pressable } from '@/components/ui/Pressable'
import { useTheme } from '@/lib/hooks/use-theme'
import { useSemanticColors } from '@/lib/theme/tokens'

/**
 * Estrellas de calificación. Read-only por defecto; con `onChange` es
 * interactiva (para dejar reseña). Compartida por detalle, tarjetas y la pantalla
 * de reseña.
 */
export function ToursStars({
  value,
  size = 16,
  onChange,
}: {
  value: number
  size?: number
  onChange?: (value: number) => void
}) {
  const { isDark } = useTheme()
  const colors = useSemanticColors(isDark)
  const interactive = typeof onChange === 'function'

  return (
    <View style={{ flexDirection: 'row', alignItems: 'center', gap: 2 }}>
      {[1, 2, 3, 4, 5].map((n) => {
        const filled = n <= Math.round(value)
        const star = (
          <Star
            size={size}
            color={filled ? colors.warning : colors.textMuted}
            fill={filled ? colors.warning : 'none'}
            strokeWidth={1.6}
          />
        )
        if (!interactive) return <View key={n}>{star}</View>
        return (
          <Pressable
            key={n}
            onPress={() => onChange?.(n)}
            accessibilityRole="button"
            accessibilityLabel={String(n)}
            testID={`tours.star-${n}`}
            style={{ padding: 2 }}
          >
            {star}
          </Pressable>
        )
      })}
    </View>
  )
}
